import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface IItemProps {
    item: IFinancialLoan
    name: string
}
// Android uses the same list_item_mp_loan.xml as the fund's loans tab:
// name (right) | قسط count (center) | amount+date (left), a translucent
// green repayment-progress band growing from the right edge (gray when
// fully repaid), a red معوق tag hanging from the top-center, and an
// optional توضیحات footer under a hairline divider.
export default function Item({ item, name }: IItemProps) {
    const navigate = useNavigate()
    const { moneyPool, poolship } = useParams()

    const payPercent =
        item.number_of_repayments > 0
            ? item.number_of_repaid_installments / item.number_of_repayments
            : 0
    const payWidth = `${Math.min(payPercent, 1) * 100}%`

    return (
        <div
            className="relative mx-4 mb-1.5 overflow-hidden rounded-[4px] border border-[#EFEFEF] bg-white cursor-pointer active:scale-[0.99]"
            onClick={() =>
                navigate(
                    `/fund/financial-history/funds-detail/${moneyPool}/${poolship}/${item.id}`,
                    {
                        state: { name },
                    }
                )
            }
        >
            {/* pay_view: repayment progress band filled from the right */}
            <div
                className="absolute inset-y-0 right-0"
                style={{
                    width: payWidth,
                    backgroundColor: item.is_fully_repaid
                        ? '#CFCDCD'
                        : '#74B74377',
                }}
            />

            {item.has_deleyed_installment && !item.is_fully_repaid ? (
                <div className="absolute top-0 left-1/2 z-[1] -translate-x-1/2 w-[65px] rounded-b-[4px] bg-[#E41F1F] p-0.5 text-center">
                    <span className="text-xs text-white">معوق</span>
                </div>
            ) : null}

            <div className="relative z-[1] grid min-h-[65px] grid-cols-3 items-center">
                {/* right (RTL first): borrower name */}
                <div className="mt-1.5 flex justify-end pr-2.5">
                    <p className="text-base font-bold text-black">
                        {item.poolship_name}
                    </p>
                </div>

                {/* center: installment count or settled tag */}
                <div className="flex justify-center">
                    {item.is_fully_repaid ? (
                        <span className="rounded-[4px] bg-[#EFEFEF] px-[5px] py-0.5 text-sm font-bold text-black">
                            تسویه شده
                        </span>
                    ) : (
                        <span className="text-sm text-black">
                            {item.number_of_repayments} قسط
                        </span>
                    )}
                </div>

                {/* left (RTL last): amount + date */}
                <div className="mt-1.5 flex flex-col items-start pl-2.5">
                    <p className="text-sm font-bold text-black">
                        {item.amount && item.amount.toLocaleString()} تومان
                    </p>
                    <p className="text-xs text-black">
                        {item?.pay_date && ConvertorMiladi(item.pay_date)}
                    </p>
                </div>
            </div>

            {item.tag && item.tag.length > 0 && (
                <div className="relative z-[1]">
                    <div className="mx-[7px] h-px bg-[#D4D4D4]" />
                    <p className="p-1 text-sm text-black">
                        توضیحات:‌ {item.tag}
                    </p>
                </div>
            )}
        </div>
    )
}
